import axios from "axios";
import { baseUrl } from "../contants/Endpoints";

export const noAuthAxios = axios.create({
  baseURL: baseUrl,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});